export default "__VITE_ASSET__5e3a596c__"